var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.feedInfo),function(item){return _c('div',{key:item.id,staticClass:"feed-info"},[_c('FeedItem',{attrs:{"feedInfo":item,"openId":_vm.openId}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }